<template>
	<li>
		<i :class="iconClass" class="sidebar_nav_icon fa fa-fw" aria-hidden="true"></i>
		<a class="nostyle" href="#" v-scroll-to="{
				el: targetId,
				duration: scrollToSpeed,
				easing: 'ease-in-out'
		}">
			<span class="sidebar_item_name">{{ name }}</span>
		</a>
	</li>
</template>

<script>
	import VueScrollTo from 'vue-scrollto';

	export default {
		name: "SidebarItem",
		props: [
			"name",
			"iconClass",
			"targetId",
			"scrollToSpeed"
		],
		directives: {
			scrollTo: VueScrollTo
		},
		data () {
			return {}
		}
	}
</script>

<style lang="scss" scoped>
	@import "../../styles/global.scss";
	@import "../../styles/text_mixins.scss";
	@import "../../styles/position_mixins.scss";
	@import "../../styles/spacing_mixins.scss";
	@import "../../styles/dimension_mixins.scss";
	@import "../../styles/transition_mixins.scss";
	@import "../../styles/background_mixins.scss";

	$sidebar_item_size: 50px;

	li {
		line-height: $sidebar_item_size;
		@include dimensions( $sidebar_item_size, $sidebar_item_size );
		& i.sidebar_nav_icon {
			position: absolute;
			line-height: 50px;
			font-size: 25px;
			@include dimensions( $sidebar_item_size, $sidebar_item_size );
		}
		& a {
			outline: 0;
			white-space: nowrap;
			@include position(
				block,
				absolute,
				$left: -400px
			);
			@include spacing( 0px, 0px 25px 0px 25px );
			@include dimensions( auto, $sidebar_item_size );
			@include background(
				$color: white,
				$box-shadow: 5px 5px 15px rgba(0, 0, 0, 0.3)
			);
			@include text(
				$font-size: 1.5em,
				$font-family: 'Barlow Condensed',
				$decoration: none
			);
			@include transition( left 0.2s ease );
			& .sidebar_item_name {
				display: inline-block;
				max-width: 300px;
				text-overflow: ellipsis;
				overflow: hidden;
			}
		}
		&:hover a {
			left: 0px;
			@include transition( left 0.2s ease );
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/sidebar/sidebarItem.vue